import styled from "styled-components";

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SwitchWrapper = styled.div`
  margin-bottom: 16px;

  > div {
    width: auto;
    justify-content: flex-start;
  }
`;

export const InputWrapper = styled.div`
  margin-bottom: 16px;
`;

export const SectionLabel = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  margin: 16px 0 8px 0;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 16px 0;
`;

export const WarningBanner = styled.div`
  background-color: #fffbeb;
  border: 1px solid #f59e0b;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #92400e;
  line-height: 1.5;
`;

export const StringListLabel = styled.span`
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #9a9aa4;
`;

export const StringListBox = styled.div<{ focused?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  width: 381px;
  min-height: 48px;
  padding: 8px 10px;
  border: 2px solid ${({ focused }) => (focused ? "#0054B6" : "#d7d8db")};
  border-radius: 4px;
  margin-top: 4.5px;
  box-sizing: border-box;
  cursor: text;
`;

export const StringListInputField = styled.input`
  flex: 1;
  min-width: 120px;
  height: 32px;
  border: none;
  outline: none;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  color: #333;
  padding: 0;

  &::placeholder {
    color: #9ca3af;
  }
`;

export const ChipItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background-color: #e8f4fd;
  border: 1px solid #b3d9f2;
  border-radius: 16px;
  font-size: 13px;
  color: #1a6fa3;
  white-space: nowrap;
`;

export const ChipRemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: none;
  font-size: 14px;
  color: #1a6fa3;
  cursor: pointer;
  line-height: 1;

  &:hover {
    color: #c53030;
  }
`;
